import { TranslateHtml } from '@change-corgi/core/react/i18n';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { iconInfoOutline } from '@change-corgi/design-system-legacy/icons';
import { Flex } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

type InfoOtherSourceParams = {
	signaturePercent: number;
};

export function InfoOtherSource({ signaturePercent }: InfoOtherSourceParams): React.JSX.Element | null {
	return (
		<Flex paddingY={8} sx={{ gap: 8, justifyContent: 'flex-start', flexDirection: 'row' }}>
			<Icon icon={iconInfoOutline} size={20} color="secondary-blue" />
			<Text size="small">
				<TranslateHtml
					value="corgi.petition.starter_dashboard.petition_insights.signature_sources.info_other_source"
					replacements={{ numPercent: signaturePercent }}
				/>
			</Text>
		</Flex>
	);
}
